<kion-markdown [project]="project" [content]="data$ | async"></kion-markdown>
